import React, { useState } from 'react'
import StepWizard, { StepWizardProps, StepChange } from 'react-step-wizard'
import { Col, Row } from 'styled-bootstrap-grid'
import { Steps } from 'antd'
import _ from 'lodash'

const { Step } = Steps

type Props = {
  stepCount: number
} & StepWizardProps

export const Wizard = ({ stepCount, children, ...props }: Props) => {
  const [step, setStep] = useState(0)

  const onChangeStep = (change: StepChange) => {
    const nextStep = change.activeStep - 1
    setStep(nextStep > 0 ? nextStep : 0)
  }

  const steps = _.range(0, stepCount)

  return (
    <>
      {stepCount > 1 && (
        <Row>
          <Col>
            <Steps current={step}>
              {_.map(steps, (item: any) => (
                <Step key={item} title="" />
              ))}
            </Steps>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <StepWizard {...props} onStepChange={onChangeStep}>
            {children}
          </StepWizard>
        </Col>
      </Row>
    </>
  )
}
